import React from 'react'
import { Planets } from 'react-preloaders';

const Loading = ({ loaderState }) => {
    return (
        <Planets customLoading={true} time={0} color={'#DEEAF8'} background="#253044" />
        // <div className="loader">


        // </div>
    );
}
export default Loading;